import type {
  UpdateRouterRequest,
  RouterInfoResponse,
} from "../../domain/types/router";
import { RouterInfoResponseSchema } from "../../domain/types/router";
import type { RouterRepository } from "../../domain/repositories/router-repository";
import { routerApiService } from "../api/router-api-service";

export class RouterRepositoryImpl implements RouterRepository {
  async updateRouter(routeId: number, request: UpdateRouterRequest): Promise<RouterInfoResponse> {
    const response = await routerApiService.updateRouter(routeId, request);

    if (response.data) {
      return RouterInfoResponseSchema.parse(response.data);
    }

    throw new Error(response.errorMsg || "라우터 정보 업데이트 실패.");
  }
}